// extracted by mini-css-extract-plugin
export default {"wrapper":"UserAvatarIcon_wrapper__lTRlW","image":"UserAvatarIcon_image__hC2Ud"};